import * as Immutable from 'immutable';
import * as React from 'react';
import ModuleIconContainer from '../../Module/_containers/ModuleIconContainer';

export interface Props extends ButtonProps<HTMLButtonElement> {
	moduleId: string
	name?: string
}

export default class ListLayerModuleItem extends React.Component<Props> {
	render() {
		return <div className="layer-module-item">
			<ModuleIconContainer moduleId={this.props.moduleId}/>
			{ this.props.name }
		</div>
	}
}